import { render, staticRenderFns } from "./ScrollBar.vue?vue&type=template&id=c5423778&scoped=true"
import script from "./ScrollBar.vue?vue&type=script&lang=js"
export * from "./ScrollBar.vue?vue&type=script&lang=js"
import style0 from "./ScrollBar.vue?vue&type=style&index=0&id=c5423778&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5423778",
  null
  
)

export default component.exports